import type { TranslationModule } from '../types';

export const uploadDrawerTranslations: TranslationModule = {
  ro: {
    title: "Adaugă fișier",
    closeAria: "Închide opțiunile de atașare",
    camera: "Cameră",
    gallery: "Galerie",
    files: "Fișiere"
  },
  en: {
    title: "Add file",
    closeAria: "Close upload options",
    camera: "Camera",
    gallery: "Gallery",
    files: "Files"
  },
  fr: {
    title: "Ajouter un fichier",
    closeAria: "Fermer les options de pièce jointe",
    camera: "Appareil photo",
    gallery: "Galerie",
    files: "Fichiers"
  }
};

export default uploadDrawerTranslations;
